<div class="overlay" *ngIf="isVisible"></div>
<div class="column-settings-panel" [class.visible]="isVisible">
  <div class="column-settings-header">
    <div class="header-top">
      <div class="title">{{ 'label.columns_settings' | translate }}</div>
      <i class="bi bi-x-lg" (click)="closeColumnsSettings()"></i>
    </div>
    <div class="header-border"></div>
  </div>
  <div class="column-search-input-group">
    <input 
      type="text" 
      class="form-control"
      [(ngModel)]="searchQuery" 
      (input)="filterColumns()"
      placeholder="{{ 'placeholders.search_columns' | translate }}"
    >
    <div class="input-group-append">
      <i class="bi bi-search"></i>
    </div>
  </div>
  <div class="column-settings-content">
    <div>
      <div *ngFor="let item of frozenColumns; let i = index" cdkDrag class="column-settings-item">
        <ng-container *ngTemplateOutlet="columnRow; context: { item: item, i: i }"></ng-container>
      </div>
    </div>
    <div cdkDropList [cdkDropListData]="columnsSettings" (cdkDropListDropped)="drop($event)" class="column-settings-list">
      <div *ngFor="let item of (searchQuery ? filteredColumnsSettings : columnsSettings); let i = index" cdkDrag class="column-settings-item" [ngClass]="{ 'p-0': item.frozenLeft }">
        @if(!item.frozenLeft) {
          <ng-container *ngTemplateOutlet="columnRow; context: { item: item, i: i }"></ng-container>
        }
      </div>
    </div>
    <div class="modal-footer no-border submit-actions column-settings-modal-footer">
      <button class="btn secondary-button" (click)="closeColumnsSettings()">{{ 'buttons.close' | translate }}</button>
      <button class="btn primary-button" (click)="applyColumnsSettings()">{{ 'buttons.apply_filters' | translate }}</button>
    </div>
  </div>
</div>

<ng-template #columnRow let-item="item" let-i="i">
  <div class="column-settings-item-wrapper">
    <div class="column-settings-item-values form-field-wrapper">
      <div class="form-check">
        <input class="form-check-input"
          [(ngModel)]="item.showColumn"
          (ngModelChange)="sortColumnsSettings()"
          type="checkbox" id="checkbox-{{item.prop}}"
          [disabled]="item.frozenLeft">
          <label class="form-field-label form-field-label__checkbox">{{ item.name | translate }}</label>
      </div>
    </div>
    @if(!item.frozenLeft){
      <div class="column-settings-item-btn">
        <button *ngIf="i !== 0" (click)="moveUp(i)" class="move-btn up-btn"><i class="bi bi-chevron-up"></i></button>
    
        <button *ngIf="i !== columnsSettings.length - 1" (click)="moveDown(i)" class="move-btn down-btn"><i class="bi bi-chevron-down"></i></button>
    
        <button cdkDragHandle class="drag-handle"><i class="bi bi-grip-vertical"></i></button>
      </div>
    }
  </div>
</ng-template>
